export class DevicePermissionKey {
  static readonly ADMIN = 'device/permission/admin';
}
